import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../../lib/brand";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AdminLogin = () => {
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0e2a1e] flex items-center justify-center px-6">
      <div className="bg-[#f4f2ea] rounded-2xl p-10 max-w-md w-full text-center">
        <img src={LOGO_URL} alt="Everyone's Budget" className="w-20 h-20 rounded-full object-cover mx-auto" />
        <h1 className="font-serif-brand text-3xl font-semibold text-[#0e2a1e] mt-6">Admin Panel</h1>
        <p className="text-[#0e2a1e]/60 mt-2 text-sm">Everyone's Budget — sign in with your authorized Google account.</p>
        <button
          onClick={handleGoogle}
          className="mt-8 w-full bg-white border border-[#0e2a1e]/15 text-[#0e2a1e] font-medium py-3 rounded-full hover:bg-[#0e2a1e] hover:text-[#f4f2ea] transition-colors flex items-center justify-center gap-3"
        >
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continue with Google
        </button>
        <Link to="/" className="block mt-6 text-xs text-[#0e2a1e]/50 hover:underline">← Back to store</Link>
      </div>
    </div>
  );
};

export default AdminLogin;
